export default {
  header: "My Feature Page",
  view: "Feature"
};
